import { Nav } from 'components/nav';
import { Fragment } from 'react';
import { Outlet } from 'react-router-dom';

function DashboardPage() {
  return (
    <Fragment>
      <Nav.Bar />
      <Outlet />
    </Fragment>
  );
}

export default DashboardPage;
